import { confirmEmailChange as confirmEmailChangeCallable } from '@griply/services';
import {
  AuthErrorKind,
  AuthFlow,
  AuthFlowError,
  ConfirmEmailChangeResponse,
  EmailChangeConfirmOutcome,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions, handleAuthError, reportAuthError } from './helpers';

const KIND_BY_OUTCOME = new Map<unknown, AuthErrorKind>([
  [EmailChangeConfirmOutcome.InvalidLink, AuthErrorKind.InvalidLink],
  [EmailChangeConfirmOutcome.EmailTaken, AuthErrorKind.EmailTaken],
]);

// Answers the address the account moved to.
export const confirmEmailChange = async (token: string): Promise<string> => {
  let result: ConfirmEmailChangeResponse;
  try {
    result = await confirmEmailChangeCallable({
      functions: getFunctions(),
      httpsCallable,
      token,
    });
  } catch (error) {
    throw handleAuthError(error, AuthFlow.ConfirmEmailChange);
  }

  if (result.outcome === EmailChangeConfirmOutcome.Confirmed) {
    return result.email;
  }
  const kind = KIND_BY_OUTCOME.get(result.outcome);
  if (kind) {
    throw new AuthFlowError(kind);
  }
  const unknownAnswer = new Error(
    'users-confirmEmailChange answered an unknown outcome',
  );
  reportAuthError(unknownAnswer, AuthFlow.ConfirmEmailChange, {
    outcome: result.outcome,
  });
  throw new AuthFlowError(AuthErrorKind.Unknown, { cause: unknownAnswer });
};
